import { API } from '../Api';

// Sổ dòng tiền sàn hợp tác + bảng thu nhập creator (kế toán/admin, quyền xem tài chính). Đặt cạnh báo cáo doanh thu ở payment
// (api/v1/transactions/...), không dưới admin/, để vai trò Kế toán (chỉ Finance.View) vào được qua gateway.

export interface BrandLedgerItem {
  atVn: string; // "dd/MM/yyyy HH:mm:ss" giờ Việt Nam, dựng sẵn ở máy chủ
  kind: string;
  dealId: string | null;
  campaignId: string | null;
  campaignTitle: string | null;
  ordererName: string;
  ordererKind: string; // "Doanh nghiệp" | "Cá nhân"
  ordererTaxCode: string | null;
  ordererIdentityName: string | null;
  creatorIdentityName: string | null;
  creatorTaxOrId: string | null; // mã số thuế hoặc "****1234"
  amountVnd: number;
  amountCa: number | null;
  note: string | null;
}

export interface BrandLedgerTotal {
  kind: string;
  amountVnd: number;
  amountCa: number;
}

export interface BrandLedgerPage {
  items: BrandLedgerItem[];
  totalItems: number;
  page: number;
  pageSize: number;
  totals: BrandLedgerTotal[];
}

export interface CreatorIncomeItem {
  creatorId: string;
  identityName: string | null;
  displayName: string;
  taxOrId: string | null;
  grossVnd: number;
  feeVnd: number;
  netVnd: number;
  dealCount: number;
  compensationVnd: number;
}

export interface CreatorIncome {
  year: number;
  month: number | null;
  items: CreatorIncomeItem[];
}

const BASE = '/v1/payment-service/transactions';

export const getBrandLedger = (from: string, to: string, page: number, pageSize: number) =>
  API.get<BrandLedgerPage>(`${BASE}/brand-ledger`, { params: { from, to, page, pageSize } }).then((r) => r.data);

export const exportBrandLedger = (from: string, to: string) =>
  API.get<BrandLedgerPage>(`${BASE}/brand-ledger/export`, { params: { from, to } }).then((r) => r.data);

const incomeParams = (year: number, month?: number) => (month ? { year, month } : { year });

export const getCreatorIncome = (year: number, month?: number) =>
  API.get<CreatorIncome>(`${BASE}/brand-creator-income`, { params: incomeParams(year, month) }).then((r) => r.data);

export const exportCreatorIncome = (year: number, month?: number) =>
  API.get<CreatorIncome>(`${BASE}/brand-creator-income/export`, { params: incomeParams(year, month) }).then((r) => r.data);
